import {
  EDIT_BUSINESS,
  EDIT_BUSINESS_CLEAN,
  EDIT_BUSINESS_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  business: undefined,
}

const BusinessEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_BUSINESS:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_BUSINESS_SUCCESS:
      state = {
        ...state,
        loading: false,
        done: true,
        business: action.payload.business,
      }
      break
    case EDIT_BUSINESS_CLEAN:
      state = initialState
      break
    case API_ERROR:
      state = {
        ...state,
        error: action.payload,
        loading: false,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default BusinessEdit
